<template>
  <div>
    <div class="navBar">
      <div v-if="!this.isHideArrow && this.$route.query.isFirstLogin !== 'true'" class="arrow" @click="handleBackClick">
        <!-- <van-icon name="arrow-left" /> -->
        <img class="backImg" src="@/assets/images/backLeftArrow.png" alt="" />
      </div>
      <p class="title">{{ title }}</p>
    </div>
    <div class="logo" v-show="ifShowLogo"><img :src="logo" alt="" /></div>
    <div class="welcome">{{ welcome }}</div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon } from 'vant'
import { getCompanyInfo } from '@/services/api'
Vue.use(Icon)
export default {
  name: 'NavBar',
  props: ['narBarTitle', 'msg', 'showLogo', 'companyCode', 'companyLogo', 'hideArrow'],
  data() {
    return {
      title: this.narBarTitle,
      welcome: this.msg,
      logo: null,
      ifShowLogo: this.showLogo ? true : false,
      isHideArrow: this.hideArrow ? true : false,
    }
  },
  methods: {
    handleBackClick() {
      if (this.$listeners['click-left']) {
        this.$emit('click-left')
      } else {
        console.log(this.$route.query)

        if (this.$route.query.isFirstLogin == 'true') {
          return
        } else {
          this.goBack()
        }
      }
    },
    goBack() {
      if (this.$parent.goBack) {
        this.$parent.goBack()
      } else {
        this.$router.back()
      }
    },
    async getLogo(companyCode) {
      const res = await getCompanyInfo(companyCode)
      if (res.logo) {
        this.logo = res.logo
      } else {
        this.logo = require('@/assets/images/logo.png')
      }
    },
  },
  mounted() {
    if (this.companyCode) {
      this.getLogo(this.companyCode)
    }
  },
  watch: {
    companyLogo: {
      handler: function () {
        this.companyLogo && (this.logo = this.companyLogo)
      },
    },
    narBarTitle: {
      handler: function () {
        this.title = this.narBarTitle
      },
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar .van-icon {
  color: #000000;
}

.navBar {
  // height: 40px;
  background: #ffffff;
  line-height: 50px;
  text-align: center;
  border-bottom: 1px solid #ececec;
  font-size: 18px;
  position: relative;

  .arrow {
    height: 100%;
    padding: 3px 19px;
    position: absolute;
  }

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #1E2329;
  }
}

.backImg {
  position: absolute;
  width: 24px;
  height: 24px;
  left: 16px;
  top: 10px;
}

.logo {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 8px;
  height: 56px;
  line-height: 56px;

  img {
    max-height: 56px;
  }
}

.welcome {
  text-align: center;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
}
</style>
